




import {
  defineComponent,
  ref,
  provide,
  onErrorCaptured,
  computed,
} from '@vue/composition-api'
import {
  initErrorHandler,
  AuthenticationError,
  ApiError,
  getLicenses,
} from '@/shared/api'
import {
  getUserSymbol,
  alertsSymbol,
  alertSymbol,
  licensesSymbol,
} from '@/shared/state-management/symbols'
import {
  provideStore as provideTextbookStore,
  useStore as useTextbookStore,
} from '@/shared/state-management/textbookStore'
import { CloseError } from '@/shared/state-management/errors'
import {
  provideStore as provideUserStore,
  useStore as useUserStore,
} from '@/shared/state-management/userStore'
interface Alert {
  id?: string
  type: string
  text: string
  timeout?: number
  done?: Function
}
export default defineComponent({
  name: 'App',
  setup(props, { root }) {
    const alerts = ref([] as Array<Alert>)
    const licenses = ref([] as Array<{ name: string; isTeacherType: boolean }>)
    provide(licensesSymbol, licenses)
    provideTextbookStore()
    provideUserStore()
    const { loadTextbooks } = useTextbookStore().actions
    const { fetchUser } = useUserStore().actions

    const alert = (anAlert: Alert): Promise<void> => {
      const id = '' + Date.now()

      const removeAlert = (anId: string) => {
        for (let index = 0; index < alerts.value.length; index++) {
          if (alerts.value[index].id === anId) {
            alerts.value.splice(index, 1)
            return
          }
        }
      }

      return new Promise((resolve, reject) => {
        alerts.value.unshift({
          ...anAlert,
          id: id,
          done: (success: boolean) => {
            removeAlert(id)
            if (success) {
              resolve()
            } else {
              reject(new CloseError())
            }
          },
        })
        if (anAlert.type !== 'confirm') {
          setTimeout(
            () => removeAlert(id),
            anAlert.timeout ? anAlert.timeout : 5000
          )
        }
      })
    }

    const handleError = (err: Error) => {
      if (err instanceof AuthenticationError) {
        root.$router.push({ name: 'Login' })
        return false
      } else if (err instanceof ApiError) {
        alert({
          text: root.$t(
            'api.error.' + (err.message ? err.message : 'unknown'),
            err.params ? err.params : {}
          ) as string,
          type: 'error',
        })
        return false
      } else if (err instanceof CloseError) {
        return false
      } else {
        throw err
      }
    }

    const getUserInfo = async () => {
      try {
        try {
          await fetchUser()
        } catch (e) {
          throw new AuthenticationError(e.message)
        }
        await loadTextbooks()
        licenses.value = await getLicenses()
      } catch (e) {
        handleError(e)
      }
    }

    const provideAlerts = computed(() => alerts.value)

    provide(alertsSymbol, provideAlerts)
    provide(alertSymbol, alert)

    provide(getUserSymbol, getUserInfo)
    initErrorHandler(handleError)
    onErrorCaptured((err: Error) => {
      if (
        err instanceof AuthenticationError ||
        err instanceof ApiError ||
        err instanceof CloseError
      ) {
        return false
      }
      throw err
    })
  },
})
